var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"streams_subheader\">\n    <span>"
    + container.escapeExpression((((helper = lookupProperty(helpers,"subheader_name") || container.strict(depth0, "subheader_name", {"start":{"line":2,"column":13},"end":{"line":2,"column":27}} ))),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"subheader_name","hash":{},"data":data,"loc":{"start":{"line":2,"column":10},"end":{"line":2,"column":30}}}) : helper)))
    + "</span>\n</div>\n";
},"useData":true});